module.exports = __webpack_public_path__ + "img/excel.76022d13.svg";